import { ApiClient } from '@webapp/core/services/ApiClient'
import { CreditCardItemRepository } from './CreditCardItemRepository'

export const creditCardItemRepository = new CreditCardItemRepository({
  httpClient: ApiClient,
})

export { type RelatedItemsResult } from './CreditCardItemRepository.types'
